module.exports = __webpack_public_path__ + "img/握手.bb147d77.png";